import { useEffect } from "react";
import { LeafletPixiContext } from "./useLeafletPixi";
import { RendererName } from "@api/pixijs/renderers/OperationRenderer";
import { useTypedSelector } from "@hooks/useTypedSelector";
import { useUnitSliceActions } from "@hooks/useActions";
import { UnitRenderer } from "@api/pixijs/renderers/UnitRenderer";
import logger from "@utils/logger";

const log = logger.getLogger("useUnitRenderer")
export default function (pixiContext: LeafletPixiContext | undefined) {
    const {
        ids: adapterIds,
        unitChangedIds
    } = useTypedSelector(data => data.units)

    const { commit } = useUnitSliceActions()
    useEffect(() => {
        if (pixiContext && unitChangedIds.length > 0) {
            const pixiOverlay = pixiContext.service
            const renderer = pixiContext.service.getRendererByName<UnitRenderer>(RendererName.Unit)
            renderer.redraw(unitChangedIds)
            pixiOverlay.refreshPixiContainer()
            commit({ changes: unitChangedIds })
        }
    }, [pixiContext, unitChangedIds])

    useEffect(() => {
        if (pixiContext) {
            const renderer = pixiContext.service.getRendererByName<UnitRenderer>(RendererName.Unit)
            const pixiOverlay = pixiContext.service
            renderer.enable()
            renderer.render(adapterIds)
            pixiOverlay.refreshPixiContainer()
        }
    }, [pixiContext, adapterIds])
}